import {Component} from 'react';
import h from 'react-hyperscript';
import {Switch} from 'react-router-dom';
import ReportCardOverview from 'Pages/ReportCardOverview/ReportCardOverview';
import GuestOverview from 'Pages/ReportCardOverview/GuestOverview';
import ReportCardSingle from 'Pages/ReportCardSingle/ReportCardSingle';
import TransformationSurvey from
  'Pages/TransformationSurvey/TransformationSurvey';
import Settings from 'Pages/Settings/Settings';
import AdminRoute from 'Components/AdminRoute/AdminRoute';
import DistrictRoute from 'Components/DistrictRoute/DistrictRoute';
import Login from 'Pages/Login/Login';

class Main extends Component {
  render() {
    if (this.props.errorMessage) {
      return (
        h('main', {
          className: 'page',
        }, this.props.errorMessage)
      );
    } else {
      const {dynamicGraphSize, screenWidth} = this.props;

      return (
        h('main', {
          className: 'page',
        },
        h(Switch, null, [
          h(AdminRoute, {
            key: 'route__report-card__key',
            csrf: this.props.csrf,
            path: '/app/',
            exact: true,
            component: ReportCardOverview,
            setLatestReportName: this.props.setLatestReportName,
            googleUser: this.props.googleUser,
            userStatus: this.props.userStatus,
            isAdmin: this.props.isAdmin,
            setProductWindowsLoading: this.props.setProductWindowsLoading,
            scopesGranted: this.props.scopesGranted,
            promptScopes: this.props.promptScopes,
          }, null),
          h(DistrictRoute, {
            key: 'route__report-card-guest__key',
            csrf: this.props.csrf,
            path: '/guest/',
            exact: true,
            component: GuestOverview,
            googleUser: this.props.googleUser,
            userStatus: this.props.userStatus,
            isAdmin: this.props.isAdmin,
          }, null),
          h(DistrictRoute, {
            key: 'route__single__report__key',
            csrf: this.props.csrf,
            path: '/app/districts/:districtId/reports/:reportId',
            exact: true,
            component: ReportCardSingle,
            googleUser: this.props.googleUser,
            userStatus: this.props.userStatus,
            setReportName: this.props.setReportName,
            setLatestReportName: this.props.setLatestReportName,
            productWindowsLoading: this.props.productWindowsLoading,
            dynamicGraphSize,
            screenWidth,
          }, null),
          h(AdminRoute, {
            key: 'route__single__report__key',
            csrf: this.props.csrf,
            path: '/app/settings/',
            exact: true,
            component: Settings,
            history: this.props.history,
            googleUser: this.props.googleUser,
            userStatus: this.props.userStatus,
            logoutClick: this.props.logoutClick,
            isAdmin: this.props.isAdmin,
            scopesGranted: this.props.scopesGranted,
            promptScopes: this.props.promptScopes,
          }, null),
          h(DistrictRoute, {
            key: 'route__survey__key',
            csrf: this.props.csrf,
            path: '/app/survey/:surveyId',
            exact: true,
            component: TransformationSurvey,
            googleUser: this.props.googleUser,
            userStatus: this.props.userStatus,
            logoutClick: this.props.logoutClick,
            fetchUserStatus: this.props.fetchUserStatus,
            dynamicGraphSize,
            screenWidth,
          }, null),
          h(Login, {
            key: 'route__survey__key',
            path: '/app/login',
            exact: true,
            isAdmin: this.props.isAdmin,
          }, null),
        ])
        )
      );
    }
  }
}

export default Main;
